import moment from 'moment/moment';

export const formatDate = (date, fallbackDate) => {
  const parsedDate = new Date(date || fallbackDate);
  return moment.utc(parsedDate).format('MM/DD/YYYY HH:mm');
};
